import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-mobile-modal-trigger',
  templateUrl: './mobile-modal-trigger.component.html',
  styleUrls: ['./mobile-modal-trigger.component.scss']
})
export class MobileModalTriggerComponent {
  @Input() count: number = 0;
  @Input() label!: string;
  @Input() isLoading!: boolean;
}
